import axiosInstance, { axiosNAKBHOInstance } from "../../../interceptor/intercetptor-inctence";

export const getReportsService = (data) => {
	return axiosInstance.post(`/api/investigation/uploaded-reports`, data);
}

export const getPatients = (data) => {
	return axiosNAKBHOInstance.post(`/api/lab-patient/master`, data)
}

// export const getPatients = (data) => {
// 	return axiosNAKBHOInstance.post(`/masterPatient`, data)
// }

export const getPatientsHospital = (data) => {
	return axiosNAKBHOInstance.post(`/api/lab-patient/master`, data)
}

// export const getPatients = (data) => {
// 	return axiosNAKBHOInstance.post(`healthcare_providers/search/patient`, data)
// }

export const getInvoiceService = (id) =>{
	return axiosInstance.get(`healthcare_providers/investigation/uploaded-reports/${id}`)
}